export default "__VITE_ASSET__CWShFKZP__"